module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("“Okay …,” Belle muttered to herself as she hunched over her desk, a sheet of graph paper spread before her, a pencil poised in her fingers, and a plethora of research books including her beloved "), _c('i', [_vm._v("Oxford English Dictionary")]), _vm._v(", the O.E.D., lying within her reach. The other hand held a licorice whip, which she nibbled at distractedly—licorice being one of her major food groups and the other being deviled eggs laced with capers. At the moment though, Belle was far too deep in thought to take much notice of what she was eating. “A plant theme for spring …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She blocked HOLLY into the crossword’s Down line, then stared at it. “And the clue could be either "), _c('i', [_vm._v("Actress Hunter")]), _vm._v(" or —— "), _c('i', [_vm._v("Golightly")]), _vm._v("…. And then there’s MAGNOLIAS, which can cross the ‘L’ in HOLLY, and the clue can be "), _c('i', [_vm._v("Steel")]), _vm._v("——, meaning that I can reference the clue with another that might be a shrub with BLUE flowers…. Maybe a hydrangea …?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hoping for inspiration from her garden, Belle looked up and out the windows of her home office, a converted rear porch whose decor positively shouted crossword: the wood floor painted in bold black-and-white squares, curtains hand-blocked with giant puzzle grids and clues, ditto lamp shades, and a pair of captain’s chairs with mix-and-match black-and-white canvas covers, as well as numerous ceramic plates and bowls displaying the tell-tale design. Any visitor not addicted to crosswords would have decided the person who’d chosen this singular theme was loony, indeed. Belle, however, loved it. “I guess I’m just a black-and-white person,” she liked to joke. “Gray areas aren’t high on my list—unless it’s the stuff that makes brains tick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rose, walked to the open rear door, and gazed at the serene morning scene, at the birds hopping in and out of the trees, or taking quick flight skyward while the occasional seagull lofted raucously overhead. Hearing Belle move from her desk brought both dogs to her side in a trice. “It’s not even ten o’clock yet, girls,” she said with a smile. “You know you don’t have another walk till noon.” But Kit and Gabby heard the ambivalence of the tone and remained expectantly close with their faces staring through the screen door at the patch of greenery that spread behind the old house on Newcastle’s historic Captain’s Walk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Belle laughed. “How am I going to finish this puzzle and then get back to editing the submissions for next year’s crossword collection if we play hooky?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither animal stirred.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On the other hand, maybe doing some yard work will prove inspirational…. Perhaps my puzzle could involve a riff on plants and the emotional qualities connected with them: pure as a lily, sweet as a rose … and ‘daisy,’ which, as we all know, is an old slang term for something that’s positively ‘peachy.’ What do you think, girls?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The “girls” said nothing, of course, but Gabby, the younger, smaller, and more terrier determined, quivered while her wet, black nose sniffed the air with rabbitlike intensity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, okay …,” Belle chuckled. “I can take a hint.” She pushed open the screen door; and the three, according to their physical and emotional characteristics, either leapt or stepped into the abundant sunshine. There was a pleasing hum of bees, a perfumy scent of lilac, the tangy aroma of growing grass, and spring’s fresh earth. The city garden, and the others adjoining it, were bursting with life and energy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This was definitely a good idea,” Belle said. “While I get the rake, you two can start picking up fallen twigs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kit and Gabby were already concentrating on this task, although “picking up” seemed to involve more chewing and playing tug-of-war than actual gathering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, there’s something to consider …,” Belle mused as she returned from the shed that held the manual lawn mower, a collection of flower pots in various stages of repair and a resident spider whose offspring took over the building on a yearly basis before blowing off toward other locales. “‘Rake,’ as in this gardening implement in my hands; ‘rake’ when applied to an angle; and ‘rake,’ the abbreviation of ‘rakehell,’ or libertine…. Hmmm, maybe this is the beginning of a home-improvement crossword—for all the ‘rakes’ out there who favor low-slung tool belts—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her speech was interrupted by the front doorbell, which set in motion a series of outraged yips from Gabby and a couple of bossy woofs from Kit. “Girls! Stop! We go through this every day at the same time. You know it’s only Artie bringing the mail.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Accompanied by her bodyguards, Belle walked inside, passing back through her office and into the living room with its eclectic thrift shop “finds.” Through the beveled glass panes flanking the front door she could see the postman, his heavy, blue-gray bag hanging on its shoulder strap, his bulldog-thick frame bending to one side to accommodate the burden. Artie always rang the bell or knocked on the door, rather than simply leaving the mail and departing in silence. He was a man who liked to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hiya, Belle. Hiya, poochies.” He held up a flat, cardboard-padded envelope. “A submission for your new puzzle collection…. Says so right here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Belle frowned slightly as she took it. “Constructors are supposed to send them to my office at the "), _c('i', [_vm._v("Crier")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, that’s how I thought you usually handled things. Can’t be too careful these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s really for copyright reasons, Artie. The "), _c('i', [_vm._v("Crier")]), _vm._v(" mail room keeps a log of everything that comes into my box. Not that I’m planning on stealing another person’s creation, but the editor-in-chief is a firm believer in legally protecting all parties.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of protection, it’s not such a swell notion that some of these crossword kooks have access to your home address. Like I said, can’t be too careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Belle shrugged. “Where there’s a will, there’s a way, Artie.” She studied the envelope. “A post office box in Newcastle … hmmm … but not a name I recognize—W. H. Everts? No Mr. or Ms. or Mrs., either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe that’s a good thing? Possibly another word game junkie has moved into town? But, hey, if you want to know where this Everts lives, you just let me know. All that stuff’s on record downtown. Everts’s gotta have filled out an address card in order to get a box.” Artie shifted his large mail satchel from one shoulder to the other. “So, how’s everything going with the hubby? Any hot new cases he’s working on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Belle smiled. “You always ask me that, Artie, and you know I can’t answer…. There are things Rosco won’t even tell "), _c('i', [_vm._v("me")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s true!” Belle laughed. “Well, thanks for this—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Artie wasn’t yet finished gabbing. “Dynamite day, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gorgeous … but I’d better get back to work if I don’t want my editor grousing at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure thing. Me, too. Can’t stand around all day yakking…. Make haste while the sun shines, or however that saying goes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe the word is ‘hay’ instead of ‘haste,’ Artie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever … I never did learn those kiddie rhymes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I don’t think it was written for children.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not ‘haste,’ huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. You could try ‘Haste maketh waste,’ though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, who doesn’t know that one. Ben Franklin, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“John Haywood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh. John Haywood. I knew there was some ‘hay’ in there somewhere.” Artie shrugged. “Well, the sun’s shining. I’m on my way. Forget the hay … and haste? That ain’t my thing. People spend too much time running from here to there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have a nice day, Artie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Walking back to her office, Belle was still chuckling as she opened the envelope and removed the crossword. “Oh, this is clever,” she said aloud. “It’s a nursery rhyme theme … and gardens …” She looked at the dogs. “You don’t think someone was peering over our fence just now, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "puzzle01"
    }
  }, [_vm._v("“BABY STEPS”")])])]), _c('a', {
    attrs: {
      "id": "puzzle01"
    }
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "images/Baby_Steps.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Across")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  1.  Contribution")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  7.  Agile")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("11.  Block letters?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("14.  Natural gas component")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("15.  Garden worker")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("16.  Chevy model")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("17.  Fairy tale, part 1")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("19.  Take the——")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("20.  Rocky peak")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("21.  “Pease-porridge——”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("22.  “——a cluck, there a cluck …”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("23.  Fairy tale, part 2")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("29.  Salt form")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("31.  The piper’s son")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("32.  “And——all in a row.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("36.  Engine additive; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("39.  Fairy tale villain")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("40.  And so on")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("41.  “See ya!”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("42.  Snake sound")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("43.  Cockleshells’ partner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("47.  “Big——”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("48.  See 11-Down")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("49.  Fairy tale, part 3")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("55.  Road sign")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("56.  ——of war")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("57.  Middle grade")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("60.  Nursery school subject")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("61.  Fairy tale, part 4")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("66.  River islet")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("67.  Pilot’s org.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("68.  Remove more fat")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("69.  Navy noncom")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("70.  Nitti foe")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("71.  “——Fideles”")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Down")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  1.  Achievement")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  2.  Air; prefix")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  3.  Guessing-game players")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  4.  Bronzed")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  5.  Yoko——")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  6.  Ring man")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  7.  “Fire away”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  8.  ——Rico")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("  9.  Little——Riding Hood")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("10.  Centuries; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("11.  Seldom see eye-to-eye, with 48-Across")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("12.  Chinny-chin-chin fuzz")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("13.  Gets by")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("18.  “—killed Cock Robin?”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("22.  Haw’s partner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("24.  ——lite")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("25.  Grasshopper & ant eliminator; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("26.  Waterloo warrior")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("27.  Flowers-by-phone folks; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("28.  MS——")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("29.  NYSE offerings")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("30.  ACLU & NRA")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("33.  Mr. Torme")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("34.  Dune buggy; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("35.  Skating surface")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("36.  Mauser mufflers")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("37.  Like a beanstalk")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("38.  Nosegay item")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("41.  Parrot’s nose")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("43.  Arabian marketplace")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("44.  Presidential nickname")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("45.  Monopoly purchase; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("46.  The big——wolf")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("47.  Pound sound")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("49.  Stern or Hayes")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("50.  Sunset——")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("51.  Numbers game")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("52.  Globe base?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("53.  Large bays")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("54.  In the past")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("58.  Amend")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("59.  Salinger character")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("61.  One-third of a Beach Boys hit")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("62.  Function")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("63.  ——Angelico")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("64.  Marry")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("65.  Nice summer")])]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "puzzle01"
    }
  }, [_vm._v("To download a PDF of this puzzle, please visit ")]), _c('a', {
    attrs: {
      "href": "http://www.openroadmedia.com/nero-blanc-crosswords",
      "target": "_blank"
    }
  }, [_vm._v("openroadmedia.com/nero-blanc-crosswords")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182a479e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 87
// module chunks = 0